import {
    // eslint-disable-next-line no-unused-vars
    EventMessage,
    EventType,
    PublicClientApplication,
  } from "@azure/msal-browser";
  import {
    AuthenticationHandler,
    Client,
  } from "@microsoft/microsoft-graph-client";
  import axios from "axios";
  import { toast } from "react-toastify";
  import i18n from "../config/languageInit";
  import { msalConfig, silentRequest, tokenRequest } from "../helpers/authConfig";
  export const msalApp = new PublicClientApplication(msalConfig);
  export class DriveItem {
    createdBy = {
      application: {
        displayName: "LegalPortalDev",
        id: "75cad38a-1982-44fc-8122-22e51eafda49",
      },
      user: {
        displayName: ".. ..",
        email: "...@daikin.com.tr",
        id: "f3204163-2c9a-43fd-b5ab-a61857a6692e",
      },
    };
    lastModifiedBy = {
      application: {
        displayName: "LegalPortalDev",
        id: "75cad38a-1982-44fc-8122-22e51eafda49",
      },
      user: {
        displayName: ".. ..",
        email: "...@daikin.com.tr",
        id: "f3204163-2c9a-43fd-b5ab-a61857a6692e",
      },
    };
    file = {
      mimeType:
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    };
    fileSystemInfo = {
      createdDateTime: "2022-03-07T13:10:03Z",
      lastModifiedDateTime: "2022-03-07T13:10:03Z",
    };
    parentReference = {
      driveId:
        "b!Xm80l5YbnEeGLXE6dcxSr7C1FV_5psNEvEX_8848110RKHhAsKtdRYHuK-Q-MpAC",
      driveType: "documentLibrary",
      id: "01LOCY6ZBEJBPFEXTOKBHIF7TCRCEBOUZX",
      path: "/drive/root:/",
      siteId: "",
    };
    cTag = "";
    createdDateTime = "2022-03-07T13:10:03Z";
    eTag = "";
    id = "75cad38a-1982-44fc-8122-22e51eafda4d";
    lastModifiedDateTime;
    name = "sample.pdf";
    size = 1;
    webUrl = "l";
    ["@microsoft.graph.downloadUrl"] = "";
  }
  
  /**
   * @typedef DriveItemVersion
   * @prop {string} id
   * @prop {{user:{id:string,displayName:string}}} lastModifiedBy
   * @prop {string} lastModifiedDateTime
   * @prop {number} size
   */
  
  /**
   * @type {EventMessage}
   */
  let tokenEvent = {};
  
  msalApp.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
      const account = event.payload.account;
      msalApp.setActiveAccount(account);
    }
    tokenEvent = event;
  });
  
  export const acquireToken = () => {
    silentRequest.account = msalApp.getActiveAccount();
    return msalApp.handleRedirectPromise().then((authResult) => {
      if (authResult) return authResult;
  
      return msalApp.acquireTokenSilent(silentRequest).catch((error) => {
        console.warn(
          "silent token acquisition fails. acquiring token using interactive method"
        );
        if (error) {
          // fallback to interaction when silent call failsmsalApp.getActiveAccount()
          tokenRequest.account = msalApp.getActiveAccount();
          if (
            !["msal:acquireTokenStart", "msal:loginStart"].includes(
              tokenEvent.eventType
            )
          ) {
            console.log(tokenRequest);
            return msalApp.acquireTokenPopup(tokenRequest).catch((err) => {
              console.error(err);
            });
          }
        } else {
          console.warn(error);
        }
      });
    });
  };
  
  class LoggingHandler {
    /**
     * @type {graph.Middleware}
     */
    nextMiddleware;
  
    async execute(context) {
      try {
        // let url;
        if (typeof context.request === "string") {
          // url = context.request;
        } else {
          //url = context.request.url;
        }
        return await this.nextMiddleware.execute(context);
      } catch (error) {
        throw error;
      }
    }
    /**
     *
     * @param {graph.Middleware} next
     */
    setNext(next) {
      this.nextMiddleware = next;
    }
  }
  class MyAuthenticationProvider {
    /**
     * This method will get called before every request to the msgraph server
     * This should return a Promise that resolves to an accessToken (in case of success) or rejects with error (in case of failure)
     * Basically this method will contain the implementation for getting and refreshing accessTokens
     */
    getAccessToken() {
      return acquireToken().then((responce) => responce.accessToken);
    }
  }
  
  class HttpMessageHandler {
    /**
     *
     * @param {graph.Context} context
     * @returns
     */
    async execute(context) {
      //let request = null;
      if (typeof context.request === "string") {
        //request = context.request;
      } else {
        // request = context.request.url;
      }
      //const urlSplit = window.location.pathname.split("/");
      // let contractId = urlSplit.length > 1 ? urlSplit[urlSplit.length - 1] : 0;
      // contractId = +contractId || 0;
      try {
        // For more information about context object refer "Context" section below
        let response = await fetch(context.request, context.options);
        // Set the response back in the context
        if (context.options.method !== "GET") {
          if (response.ok) {
            /*
            sharepointLogAdd({
              sozlesmeId: contractId,
              istek: request,
              islem: context.options.method,
              sonuc: "BASARILI",
            });
            */
          } else {
            response
              .clone()
              .text()
              .then((text) => {
                /*
                sharepointLogAdd({
                  sozlesmeId: contractId,
                  istek: request,
                  islem: context.options.method,
                  sonuc: "BASARISIZ",
                  hata: text,
                });
                */
              });
          }
        }
        context.response = response;
        return;
      } catch (error) {
        if (context.options.method !== "GET")
          /*
          sharepointLogAdd({
            sozlesmeId: contractId,
            istek: request,
            islem: context.options.method,
            sonuc: "BASARISIZ",
            hata: error instanceof Error ? error.message : JSON.stringify(error),
          });
          */
          throw error;
      }
    }
  }
  
  function getAuthenticatedClient() {
    const authProvider = new MyAuthenticationProvider();
  
    const authenticationHandler = new AuthenticationHandler(authProvider);
    const loggerhandler = new LoggingHandler();
    authenticationHandler.setNext(loggerhandler);
    loggerhandler.setNext(new HttpMessageHandler());
    return Client.initWithMiddleware({
      middleware: authenticationHandler,
      middlewareOptions: {
        loggingPrefix: "MSGraph-Client-Library",
      },
    });
  }
  const client = getAuthenticatedClient();
  
  export class GraphService {
    static get siteId() {
      return "97346f5e-1b96-479c-862d-713a75cc52af";
    }
  
    /**
     *
     * @param {string} itemId
     * @returns {Promise<DriveItem>}
     */
    getItem(itemId) {
      return client
        .api(`/sites/${GraphService.siteId}/drive/items/${itemId}`)
        .get();
    }
    /**
     *
     * @param {string} itemPath
     * @returns {Promise<DriveItem>}
     */
    static getItemByRoot(itemPath) {
      return client
        .api(`/sites/${GraphService.siteId}/drive/root:/${itemPath}`)
        .get();
    }
  
    /**
     * Verilen 'folderName' adında dizin yoksa yenisini oluşturur varsa var olanı getirir
     * @param {string} parentId
     * @param {string} folderName
     * @returns {Promise<DriveItem>}
     */
    static createFolder(parentId, folderName) {
      const driveItem = {
        name: folderName,
        folder: {},
      };
      return client
        .api(`/sites/${GraphService.siteId}/drive/items/${parentId}/children`)
        .post(driveItem)
        .catch((error) => {
          if (error.code === "nameAlreadyExists") {
            return client
              .api(
                "/sites/" +
                  GraphService.siteId +
                  "/drive/items/" +
                  parentId +
                  "/children/" +
                  folderName
              )
              .get();
          }
          throw error;
        });
    }
    /**
     *
     * @param {string} parentItemId
     * @param {File} rawFile
     * @returns
     */
    static startUploadSession(parentItemId, rawFile) {
      return client
        .api(
          `https://graph.microsoft.com/v1.0/sites/${GraphService.siteId}/drive/items/${parentItemId}:/${rawFile.name}:/createUploadSession`
        )
        .post()
        .then((result) => {
          return acquireToken().then((a) => {
            const headers = {
              Authorization: `Bearer ${a.accessToken}`,
              "Content-Range": `bytes 0-${rawFile.size - 1}/${rawFile.size}`,
              "Content-Length": rawFile.size,
            };
            return axios
              .put(result.uploadUrl, rawFile, {
                headers,
              })
              .catch((err) => {
                if (err?.statusCode === 423) {
                  toast.error(i18n.t("used_file"));
                }
                throw err;
              });
          });
        });
    }
  
    /**
     *
     * @param {string} itemId
     * @returns {Promise<DriveItem[]>}
     */
    static getDriveItemsByItemId(itemId) {
      return client
        .api(`/sites/${GraphService.siteId}/drive/items/${itemId}/children`)
        .get()
        .then((r) => r.value);
    }
  
    /**
     *
     * @param {string} itemId
     * @param {File} rawFile
     * @returns {Promise<DriveItem>}
     */
    static uploadItem(itemId, rawFile) {
      if (rawFile.size > 4000000) {
        return this.startUploadSession(itemId, rawFile, client).then(() =>
          this.getItem(itemId)
        );
      } else {
        return client
          .api(`/sites/${GraphService.siteId}/drive/items/${itemId}/content`)
          .put(rawFile)
          .catch((err) => {
            if (err?.statusCode === 423) {
              toast.error(i18n.t("used_file"));
            }
            throw err;
          });
      }
    }
  
    /**
     *
     * @param {string} parentItemId
     * @param {File} rawFile
     * @returns {Promise<DriveItem>}
     */
    static uploadNewItem(parentItemId, rawFile) {
      if (rawFile.size > 4000000) {
        return this.startUploadSession(parentItemId, rawFile).then(() =>
          this.getDriveItemsByItemId(parentItemId).then((result) => {
            return result.find((item) => item.name === rawFile.name);
          })
        );
      } else {
        return client
          .api(
            `/sites/${GraphService.siteId}/drive/items/${parentItemId}:/${rawFile.name}:/content`
          )
          .put(rawFile);
      }
    }
  
    /**
     * @link https://docs.microsoft.com/en-us/graph/api/driveitem-list-versions?view=graph-rest-1.0&tabs=http
     * @param {string} itemId
     * @returns {Promise<DriveItemVersion[]>} If successful, this method returns a 200 OK response code and collection of DriveItemVersion objects in the response body.
     */
    static getItemVersionHistory(itemId) {
      return client
        .api(`/sites/${GraphService.siteId}/drive/items/${itemId}/versions`)
        .get()
        .then((r) => r.value);
    }
  
    static deleteItem(itemId) {
      return client
        .api(`/sites/${GraphService.siteId}/drive/items/${itemId}`)
        .delete();
    }
    static getPhoto(email) {
      return client.api(`/users/${email}/photos/48x48/$value`).get();
    }
  }
  